'use client';

import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import type { Session, User } from '@supabase/supabase-js';
import { getSupabaseBrowser } from '@/lib/supabase-browser';

type AuthCtx = {
  session: Session | null;
  user: User | null;
  isLoading: boolean;
};

const Ctx = createContext<AuthCtx>({ session: null, user: null, isLoading: true });

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [session, setSession] = useState<Session | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    const init = async () => {
  const supabase = getSupabaseBrowser();
  const { data } = await supabase.auth.getSession();
  console.log('[AuthProvider] supabase.auth.getSession', data.session);
      if (!mounted) return;
      setSession(data.session ?? null);
      setIsLoading(false);
    };

    init();

  const supabase = getSupabaseBrowser();
  const { data: sub } = supabase.auth.onAuthStateChange((_event, newSession) => {
      console.log('[AuthProvider] onAuthStateChange', newSession);
      setSession(newSession);
    });

    return () => {
      mounted = false;
      sub.subscription.unsubscribe();
    };
  }, []);

  const value = useMemo(
    () => ({ session, user: session?.user ?? null, isLoading }),
    [session, isLoading]
  );

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
